import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)

const menuStore = new Vuex.Store({
  state: {
    isOpen: false,
    buttons: [],
  },
  mutations: {
    open(state, payload) {
      state.isOpen = true
      state.buttons = payload
    },
    close(state) {
      state.isOpen = false
    },
  },
  getters: {
    isOpen: function (state) {
      return state.isOpen
    },
  },
})

export default menuStore
